import React, { useContext, useEffect } from "react";
import "./AboutUs.css";
import "./ResponsiveAboutUs.css";
import FooterTwo from "../../components/footerTwo/FooterTwo";
import { dataContext } from "../../context/DataContextProviderr";
import { filterKey } from "../../helper/function";
import LoadingPage from "../../components/loadingPage/LoadingPage";

const AboutUs = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  const openInNewTab = (url) => {
    window.open(url, "_blank", "noreferrer");
  };
  const { allWebParts, isLoading } = useContext(dataContext);
  const filterAllWebParts = allWebParts?.filter(
    (x) => x.uniqueName === "aboutUs"
  );
  const filterPolicyWebParts = allWebParts?.filter(
    (x) => x.uniqueName === "policy"
  );
  return (
    <>
      {isLoading ? (
        <LoadingPage />
      ) : (
        <div className="about-us">
          <div className="top">
            <div className="left">
              <p className="p1">
                {filterKey(filterAllWebParts, "aboutus-head-title1")?.map(
                  (item) => item.Value
                )}
              </p>
              <p className="p2">
                {filterKey(filterAllWebParts, "aboutus-head-title2")?.map(
                  (item) => item.Value
                )}
              </p>
              <span>
                {filterKey(filterAllWebParts, "aboutus-head-description")?.map(
                  (item) => item.Value
                )}
              </span>
            </div>
            <div className="right">
              <div className="wallpaper"></div>
              <img
                src={filterKey(filterAllWebParts, "aboutus-head-image")?.map(
                  (item) => item.Value
                )}
                alt="logo in flour"
              />
            </div>
          </div>

          <div className="factory">
            <div className="left">
              <div className="wallpaper"></div>
              <img
                src={filterKey(filterAllWebParts, "factory-image")?.map(
                  (item) => item.Value
                )}
                alt="building flour"
              />
            </div>
            <div className="right">
              <div className="p1">
                <p>
                  {filterKey(filterAllWebParts, "factory-title-part2")?.map(
                    (item) => item.Value
                  )}
                </p>
                <p className="span">
                  {filterKey(filterAllWebParts, "factory-title-part1")?.map(
                    (item) => item.Value
                  )}
                </p>
              </div>
              <div className="p2">
                {filterKey(filterAllWebParts, "factory-title2")?.map(
                  (item) => item.Value
                )}
              </div>
              <span>
                {filterKey(filterAllWebParts, "factory-description")?.map(
                  (item) => item.Value
                )}
              </span>
            </div>
          </div>

          <div className="companies">
            <div className="top">
              <span>
                {filterKey(filterAllWebParts, "companies-title1")?.map(
                  (item) => item.Value
                )}
              </span>
              <p>
                {filterKey(filterAllWebParts, "companies-title2")?.map(
                  (item) => item.Value
                )}
              </p>
            </div>

            <div className="box-container">
              <img
                // onClick={() => openInNewTab("https://zargroup.ir/brand/zarkam")}
                src={filterKey(filterAllWebParts, "zarkam-logo")?.map(
                  (item) => item.Value
                )}
                className="zarkam"
                alt="zarkam-logo"
              />
              <img
                onClick={() => openInNewTab("https://www.zarmacaron.com/")}
                src={filterKey(filterAllWebParts, "zarmacaron-logo")?.map(
                  (item) => item.Value
                )}
                className="zarmacaron"
                alt="zarmacaron-logo"
              />
              <img
                // onClick={() => openInNewTab("#")}
                src={filterKey(filterAllWebParts, "semolina-logo")?.map(
                  (item) => item.Value
                )}
                className="semolina"
                alt="semolina-logo"
              />
              <img
                onClick={() => openInNewTab("https://www.zargroup.ir/")}
                src={filterKey(filterAllWebParts, "group-logo")?.map(
                  (item) => item.Value
                )}
                className="zargroup"
                alt="zargroup-logo"
              />
              <img
                // onClick={() => openInNewTab("http://zarflour.ir/")}
                src={filterKey(filterAllWebParts, "zarflour-logo")?.map(
                  (item) => item.Value
                )}
                className="zarflour"
                alt="zarflour-logo"
              />
              <img
                onClick={() => openInNewTab("https://zarfructose.com/")}
                src={filterKey(filterAllWebParts, "fructose-logo")?.map(
                  (item) => item.Value
                )}
                className="fructose"
                alt="fructose-logo"
              />
              <img
                onClick={() => openInNewTab("https://zaroil.ir/")}
                src={filterKey(filterAllWebParts, "zaroil-logo")?.map(
                  (item) => item.Value
                )}
                className="zaroil"
                alt="zaroil-logo"
              />
            </div>
          </div>

          <div className="qc">
            <div className="top">
              <div className="img-container">
                <img
                  src={filterKey(filterAllWebParts, "qc-image1")?.map(
                    (item) => item.Value
                  )}
                  alt="qc-pic"
                />
                <img
                  src={filterKey(filterAllWebParts, "qc-image2")?.map(
                    (item) => item.Value
                  )}
                  alt="qc-pic"
                />
                <img
                  src={filterKey(filterAllWebParts, "qc-image3")?.map(
                    (item) => item.Value
                  )}
                  alt="qc-pic"
                />
                <img
                  src={filterKey(filterAllWebParts, "qc-image4")?.map(
                    (item) => item.Value
                  )}
                  alt="qc-pic"
                />
              </div>
              <p>
                {filterKey(filterAllWebParts, "qc-title2")?.map(
                  (item) => item.Value
                )}
              </p>
              <img
                src="/pic/circle-logo.png"
                className="circle-logo"
                alt="circle-logo"
              />
            </div>
            <div className="bottom">
              <p>
                {filterKey(filterAllWebParts, "qc-title1")?.map(
                  (item) => item.Value
                )}
              </p>
              <span>
                {filterKey(filterAllWebParts, "qc-description")?.map(
                  (item) => item.Value
                )}
              </span>
            </div>
          </div>

          <div className="policy">
            <div className="content">
              <p className="p1">
                {" "}
                {filterKey(filterPolicyWebParts, "policy-title-1")?.map(
                  (item) => item.Value
                )}
              </p>
              <p className="p2">
                {" "}
                {filterKey(filterPolicyWebParts, "policy-title-2")?.map(
                  (item) => item.Value
                )}
              </p>
              <p className="items">
                {filterKey(filterPolicyWebParts, "policy-description")?.map(
                  (item) => item.Value
                )}
              </p>
              <p className="items">
                {filterKey(filterPolicyWebParts, "policy-course-1")?.map(
                  (item) => item.Value
                )}
              </p>
              <p className="items">
                {filterKey(filterPolicyWebParts, "policy-course-2")?.map(
                  (item) => item.Value
                )}
              </p>
              <p className="items">
                {filterKey(filterPolicyWebParts, "policy-course-3")?.map(
                  (item) => item.Value
                )}
              </p>
              <p className="items">
                {filterKey(filterPolicyWebParts, "policy-course-4")?.map(
                  (item) => item.Value
                )}{" "}
              </p>
              <p className="items">
                {filterKey(filterPolicyWebParts, "policy-course-5")?.map(
                  (item) => item.Value
                )}
              </p>
              <p className="items">
                {filterKey(filterPolicyWebParts, "policy-course-6")?.map(
                  (item) => item.Value
                )}
              </p>
              <p className="items">
                {filterKey(filterPolicyWebParts, "policy-course-7")?.map(
                  (item) => item.Value
                )}
              </p>
              <div className="sign">
                <div className="left">
                  <p>
                    {filterKey(filterPolicyWebParts, "ceo-zarflour-name")?.map(
                      (item) => item.Value
                    )}{" "}
                  </p>

                  <span>
                    {filterKey(filterPolicyWebParts, "ceo-zarflour-title")?.map(
                      (item) => item.Value
                    )}
                  </span>
                </div>
                <div className="center">
                  <p>
                    {filterKey(filterPolicyWebParts, "ceo-zargroup-name")?.map(
                      (item) => item.Value
                    )}{" "}
                  </p>

                  <span>
                    {filterKey(filterPolicyWebParts, "ceo-zargroup-title")?.map(
                      (item) => item.Value
                    )}
                  </span>
                </div>
                <div className="right">
                  <p>
                    {" "}
                    {filterKey(filterPolicyWebParts, "ceo-semolina-name")?.map(
                      (item) => item.Value
                    )}
                  </p>
                  <span>
                    {filterKey(filterPolicyWebParts, "ceo-semolina-title")?.map(
                      (item) => item.Value
                    )}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <FooterTwo />
        </div>
      )}
    </>
  );
};

export default AboutUs;
